
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("aA4MZ", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $7b40fb2e1304a7d0$export$2cd8252107eb640b; });
// ====================================================================================
// scrollToTop.module
// ====================================================================================
const $7b40fb2e1304a7d0$var$button = document.querySelector(".scroll-to-top");
const $7b40fb2e1304a7d0$var$header = document.querySelector(".header");
const $7b40fb2e1304a7d0$var$footerBottom = document.querySelector(".footer__bottom");
const $7b40fb2e1304a7d0$var$elementIsInViewport = (el)=>{
    if (!el) return false;
    const { top: top, bottom: bottom } = el.getBoundingClientRect();
    const { innerHeight: innerHeight } = window;
    return top >= 0 && top <= innerHeight || bottom >= 0 && bottom <= innerHeight;
};
const $7b40fb2e1304a7d0$var$updateScrollToTop = ()=>{
    let scrollTop = window.scrollY || document.documentElement.scrollTop;
    if ($7b40fb2e1304a7d0$var$footerBottom) {
        let winWidth = window.innerWidth;
        if (winWidth <= 420) {
            let visible = $7b40fb2e1304a7d0$var$elementIsInViewport($7b40fb2e1304a7d0$var$footerBottom, true);
            console.log("visible", visible);
            if ($7b40fb2e1304a7d0$var$elementIsInViewport($7b40fb2e1304a7d0$var$footerBottom, true)) $7b40fb2e1304a7d0$var$button.style.bottom = $7b40fb2e1304a7d0$var$footerBottom.clientHeight + 5 + "px";
            else $7b40fb2e1304a7d0$var$button.style.bottom = "";
        }
    }
    if (scrollTop > $7b40fb2e1304a7d0$var$header.clientHeight) $7b40fb2e1304a7d0$var$button.classList.add("active");
    else $7b40fb2e1304a7d0$var$button.classList.remove("active");
};
const $7b40fb2e1304a7d0$var$scrollToTop = ()=>{
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};
const $7b40fb2e1304a7d0$export$2cd8252107eb640b = ()=>{
    if (!$7b40fb2e1304a7d0$var$button) return;
    $7b40fb2e1304a7d0$var$updateScrollToTop();
    $7b40fb2e1304a7d0$var$button.addEventListener("click", $7b40fb2e1304a7d0$var$scrollToTop);
    document.addEventListener("resize", $7b40fb2e1304a7d0$var$updateScrollToTop);
    document.addEventListener("scroll", $7b40fb2e1304a7d0$var$updateScrollToTop);
    document.addEventListener("load", $7b40fb2e1304a7d0$var$updateScrollToTop);
};

});


//# sourceMappingURL=scrollToTop.module.2f243ff3.js.map
